import { getDefaultCountryFilter } from 'common/features/Filters/predefined/Country/store/country.defaults';
import { getDefaultInterestFilter } from 'common/features/Filters/predefined/Interests/store/interests.defaults';
import { FollowersFiltersState } from './filter.types';

export const getDefaultFilters = (): FollowersFiltersState => ({
  sort: 'byDate',
  ...getDefaultInterestFilter(),
  ...getDefaultCountryFilter(),
});

export const filterInitialState: FollowersFiltersState = getDefaultFilters();
